<template>
  <div class="container" v-show="loadOk" @click="saveEvent()">
    <div class="lineContainer">
      <hr class="horizontal-line"/>
      <div>or</div>
      <hr class="horizontal-line"/>
    </div>
    <div class="signButton" id="signButton" style="opacity: 0;"/>
    <div class="loginElements"
         :style="{backgroundImage:'url('+require('../../assets/images/login/googleLogin.webp')+')'}"/>
  </div>
</template>
<script>
import logo from '@/assets/images/login/googleLogin.webp'
import {jwtDecode} from 'jwt-decode'
import googleConfig from './gp.json'
// 声明 google 为全局变量
/* global google */
export default {
  name: 'GoogleLogin',
  props: ['LoginMethod'],
  data () {
    return {
      logo,
      loadOk: false,
      isVIRLogin: localStorage.getItem('isVIRLogin')
    }
  },
  mounted () {
    this.loadGoogleAPI()
  },
  methods: {
    saveEvent () {
      // const firstGoogleClick = localStorage.getItem('firstGoogleClick')
      // if (!firstGoogleClick && localStorage.getItem('visitorCode')) {
      //   const param1 = window.Android ? 1 : 0
      //   const param2 = {
      //     VisitorCode: localStorage.getItem('visitorCode')
      //   }
      //   LogUtils.saveUserEventParams('firstGoogleClick', '', param1, JSON.stringify(param2))
      //   localStorage.setItem('firstGoogleClick', new Date().getTime())
      // }
    },
    handleCredentialResponse (response) {
      // 处理用户响应
      const token = response.credential
      const decoded = jwtDecode(token)
      if (decoded && decoded.sub) {
        this.LoginMethod(token, decoded.sub, decoded.email)
      }
    },
    loadGoogleAPI () {
      const script = document.createElement('script')
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      document.body.appendChild(script)
      script.onload = () => {
        google.accounts.id.initialize({
          client_id: googleConfig.web.client_id,
          callback: this.handleCredentialResponse
        })
        google.accounts.id.renderButton(
          document.querySelector('.signButton'),
          {theme: 'outline', size: 'large', type: 'standard'}
        )
        this.onGoogleAPIInitialized()
      }
    },
    onGoogleAPIInitialized () {
      let doc = document.getElementById('signButton')
      if (doc) {
        this.setWidthRecursively(doc)
      }
      this.loadOk = true
    },
    setWidthRecursively (element) {
      element.style.width = '85.555vw'
      element.style.height = '11.111vw'
      for (let i = 0; i < element.children.length; i++) {
        this.setWidthRecursively(element.children[i])
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 85.555vw;
  height: max-content;

  .lineContainer {
    margin: 3.25vw auto 4vw auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(292vw / 3.6);
    height: 4.444vw;
    text-align: center;
    font-size: 3.611vw;
    font-weight: 500;
    color: #94A3B8;

    .horizontal-line {
      width: 35vw;
      border: none;
      border-top: 0.3vw solid #E2E8F0;
      margin: 0;
    }
  }

  .loginElements {
    width: calc(292vw / 3.6);
    height: calc(44vw / 3.6);
    margin: 0 auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .signButton {
    position: absolute;
    left: 50%;
    width: 85.555vw;
    transform: translate(-50%);
    bottom: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleAuth/index.vue